module.exports = __webpack_public_path__ + "img/combo3.5c5fa07d.png";